import { useMutation } from "@tanstack/react-query";
import { resetPassword } from "../../apis/auth";

type ResetPasswordParams = {
  email: string;
  code: string;
  password: string;
  confirmPassword: string;
};

export function useResetPassword() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({
      email,
      code,
      password,
      confirmPassword,
    }: ResetPasswordParams) => {
      return resetPassword(email, code, password, confirmPassword);
    },
  });

  return {
    resetPassword: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
